import VisibilityIcon from "@mui/icons-material/Visibility";
import {
	Box,
	IconButton,
	TableCell,
	TableRow,
	Tooltip,
	Typography,
	useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { imgUrl } from "src/Helpers/utils/constants";
import Toaster from "src/Toaster/Toaster";
import { ImemberTableRow } from "src/Types/module/member/memberTypes";
import { getStatusLabel } from "src/Utils/Combined";

const MemberTableRow = ({ allMembers }: ImemberTableRow) => {
	const Toast = Toaster();
	const theme = useTheme();

	return (
		<>
			<TableRow hover key={allMembers.user_member_id}>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{allMembers.user_member_id}
					</Typography>
				</TableCell>
				<TableCell>
					<Box sx={{ display: "flex", alignItems: "center" }}>
						<img
							width={30}
							height={30}
							style={{
								borderRadius: "50%",
								marginRight: "10px",
							}}
							src={
								allMembers.user_member_representative_photo
									? `${imgUrl}/company_representative_files/${allMembers.user_member_representative_photo}`
									: "/static/images/avatars/avatar2.png"
							}
							alt=""
						/>

						<Typography
							variant="body1"
							color="text.primary"
							gutterBottom
							noWrap
						>
							{allMembers.user_member_company_name}
						</Typography>
					</Box>
				</TableCell>

				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{allMembers.user_member_phone}
					</Typography>
				</TableCell>

				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{allMembers.user_member_zone_name}
					</Typography>
				</TableCell>
				<TableCell>
					{getStatusLabel(allMembers.user_member_account_status)}
				</TableCell>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{getStatusLabel(
							allMembers.user_member_payment_verified_status
						)}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{getStatusLabel(
							allMembers.user_member_info_verified_status
						)}
					</Typography>
				</TableCell>
				<TableCell>
					<Link
						to={`/member-list/${allMembers.user_member_id.toString()}`}
					>
						<Tooltip title="View" arrow>
							<IconButton
								sx={{
									"&:hover": {
										background:
											theme.colors.primary.lighter,
									},
									color: theme.palette.primary.main,
								}}
								color="inherit"
								size="small"
							>
								<VisibilityIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Link>
				</TableCell>
			</TableRow>
		</>
	);
};

export default MemberTableRow;
